import { GetSybilStatusResponse } from '../../types/rewards';

export const getSybilStatusModel = (response: GetSybilStatusResponse): GetSybilStatusResponse => response;
